import { render } from "./select_arrow.vue?vue&type=template&id=4892320e&scoped=true"
import script from "./select_arrow.vue?vue&type=script&lang=js"
export * from "./select_arrow.vue?vue&type=script&lang=js"

import "./select_arrow.vue?vue&type=style&index=0&id=4892320e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4892320e"]])

export default __exports__